var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65638 3.01932V5.88384H12.546C14.0185 5.88384 14.5093 6.36127 14.5093 7.79353V13.5226H12.546V11.6129C12.546 10.1806 12.0552 9.70321 10.5828 9.70321H6.65638V12.5677L0.766724 7.79353L6.65638 3.01932Z",
    fill: "url(#paint0_linear_398_54592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14712 2V5.40642H12.546C13.3094 5.40642 13.9745 5.52402 14.4268 5.964C14.8791 6.40397 15 7.05094 15 7.79353V14H12.0552V11.6129C12.0552 10.9232 11.9307 10.6153 11.7695 10.4585C11.6083 10.3017 11.2918 10.1806 10.5828 10.1806H7.14712V13.5871L0 7.79353L7.14712 2ZM1.53332 7.79353L6.16551 11.5484V9.22579H10.5828C11.3462 9.22579 12.0113 9.34339 12.4636 9.78337C12.9159 10.2233 13.0368 10.8703 13.0368 11.6129V13.0452H14.0184V7.79353C14.0184 7.10384 13.8939 6.79598 13.7327 6.63917C13.5715 6.48237 13.255 6.36126 12.546 6.36126H6.16551V4.03863L1.53332 7.79353Z",
    fill: "#626262"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_54592",
    x1: 7.63799,
    y1: 3.01932,
    x2: 7.63799,
    y2: 13.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.12f99af560e964aebd385db97b0b189c.svg";
export { ForwardRef as ReactComponent };